'use client';

import dynamic from 'next/dynamic';
import { FC } from 'react';
import { ReactPlayerProps } from 'react-player';

// dynamic is used to avoid hydration error
const ReactPlayer = dynamic(() => import('react-player'), { ssr: false });

export const Video: FC<ReactPlayerProps> = ({
  className,
  width = '100%',
  height = '100%',
  ...props
}) => {
  return (
    <ReactPlayer
      className={className}
      width={width}
      height={height}
      {...props}
    />
  );
};
